import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import LogoImg from "components/LogoImg";
import { extensionCheck, isValidBizNo } from "data/data";
import { LoadingButton } from "@mui/lab";
import JoinCheckPage from "./JoinCheck";
import { getCoordsByAddress } from "components/axios/geocode";
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import AddressSearchSwitcher from "components/layer/AddressSearchSwitcher";
import { useEnumApi } from "contexts/EnumApiContext";
import { getCheckDupleEmail, getCheckDupleLoginId, postCompanyAndUsers } from "components/axios/joinAxios";

const JoinPage = () => {
    const { t } = useTranslation();
    const { getEnumValueByEnumName } = useEnumApi();
    const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
    const timezone      = (process.env.REACT_APP_TIMEZONE || 'Asia/Seoul').toLowerCase();

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
        onClose : () => {
            //console.log(1111);
        },
        message: alertMessage,
        });
    };

    const [companyCheck, setCompanyCheck] = useState(false);
    const [company, setCompany] = useState(null);
    const { control, register, handleSubmit, watch, reset, setValue, formState : {isDirty, errors } } = useForm({
        defaultValues: {
            companyType: '', // 또는 기본 선택될 값
        }
    });

    const [businessRegFile, setBusinessRegFile] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [isUserIdCheck, setIsUserIdCheck] = useState(false);
    const [isEmailCheck, setIsEmailCheck] = useState(false);
    const [userId, setUserId] = useState('');
    const [email, setEmail] = useState('');
    const [fileLoading, setFileLoading] = useState(false);
    const [addressInfo, setAddressInfo] = useState({});

    //email& 비밀번호 정규식  
    const emailRegEx = /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/i;
    // const passwordRegEx = /^[A-Za-z0-9]{8,20}$/
    const passwordRegEx = /^\S{8,20}$/; // 설명: 공백문자 없이 8~20자 (공백 포함 불허)
    // const passwordRegEx = /^(?=.*[^\w\s])\S{8,20}$/; // 설명: 공백문자 없이 8~20자 (공백 포함 불허)
    
    // companyType 필드의 값을 실시간으로 감시
    const selectedCompanyType = watch('companyType');
    // 관리주체('MAN')일 때만 주소를 필수값으로 설정
    const isAddressRequired = selectedCompanyType === 'MAN';

    useEffect(()=> {
        // console.log(company)
        if (company) {
            setValue("businessName", company.name);
            if (company.id) {
                // console.log(company.companies?.filter(c=>c.type === 'MAN').length)
                // setValue("companyId", company.companyId);
                setValue("address", company.address);
                setValue("businessContact", company.contact);
                setValue("businessRegNo", company.businessRegNo);
                let addressinfo = {
                    address_name: company?.address
                }
                // if (appLanguage === 'zh-cn') {
                if (timezone === ('Asia/Shanghai').toLowerCase()) {
                    addressinfo.chinaRegionCode = company?.chinaRegionCode ?? null;
                } else {
                    addressinfo.lat = company?.latitude ?? null;
                    addressinfo.lng = company?.longitude ?? null;
                }
                setAddressInfo(addressinfo)
                // setValue("companyType", company.type);
            }
        }
    },[company])

    // 등록
    const onSubmit = async(data) => {
        setFileLoading(true);
        console.log(data);

        const companyId         = data.companyId;
        const companyType       = data.companyType;
        // const businessType      = data.businessType;
        const businessName      = data.businessName;
        const address           = data.address;
        const businessContact   = data.businessContact;
        const businessRegNo     = data.businessRegNo;
        // const businessStatus    = data.businessStatus;
        const loginId           = data.loginId;
        const password          = data.password;
        const name              = data.name;
        const contact           = data.contact;
        const email             = data.email;
        // const status            = data.status;

        let formData = new FormData();
        let dto = {
            user : {
                loginId: loginId,
                password: password,
                name: name,
                email: email,
                contact: contact,
            },
        };

        if (companyId) {
            dto.company = {
                type: companyType,
                info : {id : companyId},
            }
        } else {
            dto.company = {
                type: companyType,
                info : {
                    businessRegNo: businessRegNo,
                    name: businessName,
                    address: address,
                    contact: businessContact,
                    // latitude : addressInfo?.lat,
                    // longitude : addressInfo?.lng
                }
            }
            // if (appLanguage === 'zh-cn') {
            if (timezone === ('Asia/Shanghai').toLowerCase()) {
                dto.company.info.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
            } else {
                dto.company.info.latitude = addressInfo?.lat ?? null;
                dto.company.info.longitude = addressInfo?.lng ?? null;
            }
        }

        // 관리주체로 업체정보를 등록하면서 해당 업체가 관리주체로 등록된 적이 없는 경우에만 기본 구역 정보 추가
        if (platformServer !== 'NANTONG') { // 난퉁에서는 구역을 역정보로 사용하니까 기본구역을 추가하지 않는다.
            if (companyType === 'MAN' && company.companies?.filter(c=>c.type === 'MAN').length === 0) {
                let zone = {
                    name : t('message.common.text.default'), 
                    address : addressInfo?.address_name,
                    // latitude : addressInfo?.lat,
                    // longitude : addressInfo?.lng
                }
                // if (appLanguage === 'zh-cn') {
                if (timezone === ('Asia/Shanghai').toLowerCase()) {
                    zone.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
                } else {
                    zone.latitude = addressInfo?.lat ?? null;
                    zone.longitude = addressInfo?.lng ?? null;
                }
                dto.company.equipmentZones = [zone]
            }
        }
console.log(dto)
        // if (!isValidBizNo(businessRegNo)) {
        //     handleAlertClick(t('message.common.alert.business.register.no.invalid'));
        //     setFileLoading(false);
        //     return;
        // }

        if (!isUserIdCheck) {
            handleAlertClick(t('message.common.alert.id.duplication.check'));
            setFileLoading(false);
            return;
        }

        if (!isEmailCheck) {
            handleAlertClick(t('message.common.alert.email.duplication.check'));
            setFileLoading(false);
            return;
        }

        if (logoFile) {
            if (!extensionCheck(logoFile.name, "I")) {
                handleAlertClick(t('message.common.alert.file.not.match.type'));
                setFileLoading(false);
                return;
            }
            formData.append("logoFile", logoFile);
        }

        if (businessRegFile) {
            formData.append("businessRegFile", businessRegFile);
        }

// console.log(dto)
        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                postCompanyAndUsers(formData).then((res)=>{
                    console.log(res);
                    handleAlertClick(t('message.common.alert.write.done'));
                    setFileLoading(false);
                    // window.location.href = '/auth/login';
                }).catch((err)=>{
                    console.log(err);
                    handleAlertClick(err.response?.data?.message || err.message);
                    setFileLoading(false);
                });
            },
            onClose : () => {
                console.log('close');
                setFileLoading(false);
            },
            message: t('message.common.alert.write.question'),
        });
        // reset();
    };

    const dupleCheckId = () => {
        if (!userId) {
            handleAlertClick(t('message.common.alert.id.input'));
            return;
        }

        getCheckDupleLoginId({loginId:userId}).then((data)=>{
            setIsUserIdCheck(!data);
            if (data) {
                handleAlertClick(t('message.common.alert.id.use.other.id.input'));
            } else {
                handleAlertClick(t('message.common.alert.id.available'));
            }
        }).catch((err)=>{
            console.log(err);
            handleAlertClick(err.response?.data?.message || err.message);
        })
    }

    const dupleCheckEmail = () => {
        if (!email) {
            handleAlertClick(t('message.common.error.text.email.input'));
            return;
        }

        getCheckDupleEmail({email}).then((data)=>{
            setIsEmailCheck(!data);
            if (data) {
                handleAlertClick(t('message.common.alert.email.use.other.email.input'));
            } else {
                handleAlertClick(t('message.common.alert.email.available'));
            }
        }).catch((err)=>{
            console.log(err);
            handleAlertClick(err.response?.data?.message || err.message);
        })
    }

    return (
        <div 
            style={{
                minHeight: "100dvh",
                margin:"30px"
            }}
        >
            <div><Link to={'/'}><LogoImg /></Link></div>
            <div>
                <div className="mro_search">
                    <h5 className="mro_m_left" style={{color:"#fff"}}>* {t('message.common.title.company.write')}</h5>
                </div>

                {!companyCheck && 
                <JoinCheckPage setCompany={setCompany} setCompanyCheck={setCompanyCheck} />
                }
                {companyCheck &&
                <>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mro_search">
                        <h6 className="mro_m_left" style={{color:"#fff"}}>* {t('message.common.subtitle.basic.info')}</h6>
                    </div>
                    
                    <TableContainer>
                    <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width" style={{borderTop:"2px solid #a2a2a2"}} >
                        <TableBody>
                        <TableRow>
                            <TableCell className="th">{t('message.common.subtitle.company.type')} *</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                {company?.id && <input type="hidden" {...register("companyId")} value={company?.id || null} /> }
                                <Controller
                                    name="companyType"
                                    control={control}
                                    render={({ field:{ name }}) => (
                                        <CustomFormEnumSelect
                                            style={{ minWidth: '90%', margin:"8px" }}
                                            label={t('message.common.subtitle.company.type')}
                                            register={register}
                                            name={name}
                                            requiredMessage={t('message.common.error.text.company.type.select')}
                                            defaultValue={''}
                                            key={'companyType'}
                                            list={platformServer === 'NANTONG' ? getEnumValueByEnumName('CompanyType')?.filter(data=>data.code !== 'MAN') : getEnumValueByEnumName('CompanyType')}
                                        />
                                    )}
                                    rules={{ required: true }}
                                />
                                {errors.companyType && <small role="alert"><br></br>{errors.companyType.message}</small>}
                            </TableCell>
                            {/* <TableCell className="th">{t('message.common.subtitle.business.type')}</TableCell>
                            <TableCell style={{textAlign: "left"}}>
                                <Controller
                                    name="businessType"
                                    control={control}
                                    render={({ field: {name} }) => (
                                        <CustomFormSelect
                                            style={{ minWidth: '90%', margin:"8px" }}
                                            label={t('message.common.subtitle.business.type')}
                                            register={register}
                                            name={name}
                                            requiredMessage={t('message.common.error.text.business.type.select')}
                                            defaultValue={''}
                                            key={'businessType'}
                                            list={[]}
                                        />
                                    )}
                                    rules={{ required: true }}
                                />
                                {errors.businessType && <small role="alert"><br></br>{errors.businessType.message}</small>}
                            </TableCell> */}
                        </TableRow>
                        <TableRow>
                            <TableCell className="th">{t('message.common.subtitle.company.name')} *</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                {company?.name && 
                                <TextField id="businessName" 
                                    {...register("businessName", {
                                    })} 
                                    InputProps={{ readOnly: true }}
                                    sx={{ m: 1, minWidth: '90%' }}
                                />
                                }
                                {!company?.name && 
                                <>
                                <TextField id="businessName" 
                                    aria-invalid={!isDirty ? undefined : errors.businessName ? "true" : "false"}
                                    defaultValue={''}
                                    key={'businessName'}
                                    {...register("businessName", {
                                        required : t('message.common.error.text.company.name.input')
                                    })} 
                                    sx={{ m: 1, minWidth: '90%' }} 
                                />
                                {errors.businessName && <small role="alert"><br></br>{errors.businessName.message}</small>}
                                </>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="th">{t('message.common.subtitle.address')} {isAddressRequired && <>*</>}</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                {company?.address && 
                                <TextField id="address" 
                                    {...register("address", {
                                    })} 
                                    InputProps={{ readOnly: true }}
                                    sx={{ m: 1, minWidth: '90%' }}
                                />
                                }
                                {!company?.address && 
                                <>
                                {/* <TextField id="address" 
                                    aria-invalid={!isDirty ? undefined : errors.address ? "true" : "false"}
                                    {...register("address", {
                                        required : t('message.common.error.text.address.input')
                                    })} 
                                    defaultValue={''}
                                    key={'address'}
                                    sx={{ m: 1, minWidth: '60%', width: '60%' }}
                                    // onChange={(e)=>{getCoordsByAddress(e.target.value)}}
                                    // onClick={()=>{setIsCheck(false);}}
                                    // onChange={(event) => {setUserId(event.target.value); setIsCheck(false);}}
                                /> */}
                                {/* <AddressSearchSwitcher control={control} register={register} setValue={setValue} isDirty={isDirty} errors={errors} setAddressInfo={setAddressInfo} objName={'address'} /> */}
                                <Controller
                                    control={control}
                                    name="address"
                                    rules={{ required: t('message.common.error.text.address.input') }}
                                    render={({ field, fieldState }) => (
                                    <AddressSearchSwitcher register={register} setValue={setValue} field={field} fieldState={fieldState} 
                                        errors={errors} setAddressInfo={setAddressInfo} objName={'address'} />
                                    )}
                                />
                                {errors.address && <small role="alert"><br></br>{errors.address.message}</small>}
                                {/* {errors.address && <small role="alert"><br></br>{errors.address.message}</small>} */}
                                </>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="th">{t('message.common.subtitle.company.contact')}</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                {company?.contact && 
                                <TextField id="businessContact" 
                                    {...register("businessContact", {
                                    })} 
                                    InputProps={{ readOnly: true }}
                                    sx={{ m: 1, minWidth: '90%' }}
                                />
                                }
                                {!company?.contact && 
                                <>
                                <TextField id="businessContact" 
                                    // aria-invalid={!isDirty ? undefined : errors.businessContact ? "true" : "false"}
                                    {...register("businessContact", {
                                        // required : t('message.common.error.text.company.contact.input'),
                                    })} 
                                    sx={{ m: 1, minWidth: '90%' }}
                                />
                                {/* {errors.businessContact && <small role="alert"><br></br>{errors.businessContact.message}</small>} */}
                                </>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="th" style={{width:"130px"}}>{t('message.common.subtitle.business.register.no')}</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                {company?.businessRegNo && 
                                <TextField id="businessRegNo" 
                                    {...register("businessRegNo", {
                                    })} 
                                    InputProps={{ readOnly: true }}
                                    sx={{ m: 1, minWidth: '90%' }}
                                />
                                }
                                {!company?.businessRegNo && 
                                <>
                                <TextField id="businessRegNo" 
                                    // aria-invalid={!isDirty ? undefined : errors.businessRegNo ? "true" : "false"}
                                    {...register("businessRegNo", {
                                        // required : t('message.common.error.text.business.register.no.input'),
                                        // validate: (value) =>
                                        //     isValidBizNo(value) || t('message.common.alert.business.register.no.invalid'),
                                    })} 
                                    sx={{ m: 1, minWidth: '90%' }}
                                    // error={!!errors.businessRegNo}
                                />
                                {/* {errors.businessRegNo && <small role="alert"><br></br>{errors.businessRegNo.message}</small>} */}
                                </>
                                }
                            </TableCell>
                        </TableRow>
                        {/* {!company?.id && 
                        <TableRow>
                            <TableCell className="th" style={{width:"130px"}}>{t('message.common.subtitle.business.register.file')}</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                <input
                                    style={{margin:"8px"}}
                                    type="file" 
                                    onChange={(e)=>setBusinessRegFile(e.target.files[0])}
                                />
                            </TableCell>
                        </TableRow>
                        }
                        {!company?.id && 
                        <TableRow>
                            <TableCell className="th">{t('message.common.subtitle.company.logo')}</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                <input
                                    style={{margin:"8px"}}
                                    type="file" 
                                    accept={'.jpg,.jpeg,.png,.gif'}
                                    onChange={(e)=>setLogoFile(e.target.files[0])}
                                />
                            </TableCell>
                        </TableRow>
                        } */}
                        </TableBody>
                    </Table>
                    </TableContainer>

                    <div className="mro_search">
                        <h6 className="mro_m_left" style={{color:"#fff"}}>* {t('message.common.title.login.info')}</h6>
                    </div>
                    
                    <TableContainer>
                    <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width" style={{borderTop:"2px solid #a2a2a2"}} >
                        <TableBody>
                        <TableRow>
                            <TableCell className="th">ID *</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                <TextField id="loginId" 
                                    aria-invalid={!isDirty ? undefined : errors.loginId ? "true" : "false"}
                                    {...register("loginId", {
                                    required : t('message.common.error.text.id.input')
                                    })} 
                                    defaultValue={''}
                                    key={'loginId'}
                                    sx={{ m: 1, minWidth: '60%', width: '60%' }}
                                    autoComplete="new-loginId"
                                    onClick={()=>{setIsUserIdCheck(false);}}
                                    onChange={(event) => {setUserId(event.target.value); setIsUserIdCheck(false);}} />
                                <Button variant="contained" color="primary" size="small" sx={{top:"12px"}} onClick={()=>{dupleCheckId()}}>{t('message.common.btn.duplication.check')}</Button>
                                {errors.loginId && <small role="alert"><br></br>{errors.loginId.message}</small>}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="th">{t('message.common.subtitle.password')} *</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                <TextField id="password" 
                                    aria-invalid={!isDirty ? undefined : errors.password ? "true" : "false"}
                                    {...register("password", {
                                    required : t('message.common.error.text.password.input'),
                                    pattern : {
                                        value : passwordRegEx,
                                        message : "invalid password"
                                    }
                                    })} 
                                    type="password"
                                    autoComplete="new-password"
                                    sx={{ m: 1, minWidth: '80%' }} 
                                />
                                <span>* {t('message.common.text.password.rule')}</span>
                                {errors.password && <small role="alert"><br></br>{errors.password.message}</small>}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="th">{t('message.common.subtitle.manager.name')} *</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                <TextField id="name" 
                                    aria-invalid={!isDirty ? undefined : errors.name ? "true" : "false"}
                                    defaultValue={''}
                                    key={'name'}
                                    {...register("name", {
                                        required : t('message.common.error.text.manager.name.input')
                                    })} 
                                    sx={{ m: 1, minWidth: '90%' }} 
                                />
                                {errors.name && <small role="alert"><br></br>{errors.name.message}</small>}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="th">{t('message.common.subtitle.manager.contact')}</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                <TextField id="contact" 
                                    // aria-invalid={!isDirty ? undefined : errors.contact ? "true" : "false"}
                                    {...register("contact", {
                                        // required : t('message.common.error.text.manager.contact.input')
                                    })} 
                                    defaultValue={''}
                                    key={'contact'}
                                    sx={{ m: 1, minWidth: '60%', width: '60%' }}
                                />
                                {/* {errors.contact && <small role="alert"><br></br>{errors.contact.message}</small>} */}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="th">{t('message.common.subtitle.email')} *</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                <TextField id="email" 
                                    aria-invalid={!isDirty ? undefined : errors.email ? "true" : "false"}
                                    {...register("email", {
                                        required : t('message.common.error.text.email.input'),
                                        pattern : {
                                            value : emailRegEx,
                                            message : "invalid email address"
                                        }
                                    })} 
                                    defaultValue={''}
                                    sx={{ m: 1, minWidth: '70%' }}
                                    onClick={()=>{setIsEmailCheck(false);}}
                                    onChange={(event) => {setEmail(event.target.value); setIsEmailCheck(false);}}
                                />
                                <Button variant="contained" color="primary" size="small" sx={{top:"12px"}} onClick={()=>{dupleCheckEmail()}}>{t('message.common.btn.duplication.check')}</Button>
                                {errors.email && <small role="alert" style={{whiteSpace:"pre-wrap"}}><br></br>{errors.email.message}</small>}
                            </TableCell>
                        </TableRow>
                        {/* <TableRow>
                            <TableCell className="th">{t('message.common.subtitle.status')}</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <Controller
                                control={control}
                                name="status"
                                render={({ field: {name} }) => (
                                <CustomFormEnumSelect
                                    style={{ minWidth: '90%', margin:"8px" }}
                                    label={t('message.common.subtitle.status')}
                                    register={register}
                                    name={name}
                                    requiredMessage={t('message.common.error.text.status.select')}
                                    defaultValue={''}
                                    list={[]}
                                />
                                )}
                                rules={{ required: true }}
                            />
                            {errors.status && <small role="alert"><br></br>{errors.status.message}</small>}
                            </TableCell>
                        </TableRow> */}
                        </TableBody>
                    </Table>
                    </TableContainer>
                </form>
                
                <div style={{marginTop:"10px",display: "flex",justifyContent: "space-between",}}>
                    <div>
                        {/* <Link to={'/auth/login'}><Button variant="contained" color="primary" style={{backgroundColor:"#333"}}>{t('message.common.btn.return')}</Button></Link> */}
                        <Link onClick={()=>{reset();setCompanyCheck(false); setCompany(null);}}><Button variant="contained" color="primary" style={{backgroundColor:"#333"}}>{t('message.common.btn.return')}</Button></Link>
                    </div>
                    <div>
                        <LoadingButton variant="contained" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</LoadingButton>
                        {/* <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</Button> */}
                    </div>
                </div>
                </>
                }
            </div>
        </div>
    )
}

export default JoinPage;